import { Pipe, PipeTransform } from '@angular/core';
import { Column } from '../../../interfaces';

@Pipe({
  name: 'columnAlignment',
  standalone: true,
})
export class ColumnAlignmentPipe implements PipeTransform {
  /**
   * Retornar a alinhamento da coluna conforme o tipo de dado ou sua propriedade align
   */
  transform(column: Column): string {
    const type = column?.type ?? '';
    const { name } = column;
    let { align } = column;

    // Defini alinhamento para a direita se for uma coluna de ações
    if (!align && name === 'actions') {
      align = 'right';
    }

    // Mapeamento dos tipos de alinhamento.
    // `BADGE` entra centralizado: o chip tem padding próprio, então alinhado à esquerda o rótulo
    // dentro dele nasce deslocado do título da coluna e a coluna parece torta.
    const centerTypes = ['NUMBER', 'DATE4', 'TIME', 'DATETIME', 'TIMESTAMP', 'BADGE'];
    const rightTypes = ['FLOAT2', 'FLOAT4', 'CURRENCY'];

    if (align === 'center' || centerTypes.includes(type) || (type === 'DATE' && align !== 'left')) {
      return 'justify-center';
    } else if (align === 'right' || rightTypes.includes(type)) {
      return 'justify-end';
    }

    return 'justify-start';
  }
}
